import { ElxPivot, IElxPivotProps } from '@elixir/components';
import React from 'react';

export const EHPivot = (props: IElxPivotProps): JSX.Element => {
  return <ElxPivot {...props} />;
};
